import { Col, Modal, Row, Tag, TimePicker } from "antd";
import React, { useEffect, useState } from "react";
import { formatDate, formatDateWithDay } from "../../../../shared/helpers";
import moment from "moment";
import { SHIFT_TYPE_DISPLAY_MAP } from "../../TimeSheetConstants";

const UpdateTimeModal = ({ open, handleClose, data, updateTime, loading }) => {
  const type = data?.shiftType;
  const date = data?.date;
  const clockIn = data?.clockIn?.raw;
  const clockOut = data?.clockOut?.raw;

  const [clockInValue, setClockInValue] = useState(moment(clockIn));
  const [clockOutValue, setClockOutValue] = useState(moment(clockOut));

  const handleSave = () => {
    try {
      updateTime({
        timesheetId: data?._id,
        clockIn: { raw: clockInValue?.utc().valueOf() },
        clockOut: { raw: clockOutValue?.utc().valueOf() },
      });
    } catch (error) {
      console.warn("Error at update time ", error);
    }
  };


  return (
    <Modal
      title="Update Time"
      closable={{ "aria-label": "Custom Close Button" }}
      open={open}
      onOk={handleSave}
      onCancel={handleClose}
      confirmLoading={loading}
    >
      <Row gutter={[0, 20]}>
        <Col span={24}>
          <div style={{ display: "flex", flexDirection: "column" }}>
            <Tag color="default">{SHIFT_TYPE_DISPLAY_MAP?.[type] || "N/A"}</Tag>
            {date ? formatDateWithDay(date) : "N/A"}
          </div>
        </Col>
        <Col span={24}>
          <Row gutter={[20, 0]}>
            <Col>
              <TimePicker
                use12Hours
                format="h:mm a"
                value={clockInValue}
                onChange={(e) => setClockInValue(moment(e))}
                placeholder="Clock In"
                allowClear={false}
              />
            </Col>
            <Col>
              <TimePicker
                use12Hours
                value={clockOutValue}
                format="h:mm a"
                placeholder="Clock Out"
                allowClear={false}
                onChange={(e) => setClockOutValue(moment(e))}
              />
            </Col>
          </Row>
        </Col>
      </Row>
    </Modal>
  );
};

export { UpdateTimeModal };
